<template>
    <div class="table-responsive">
        <table>
            <thead>
                <tr>
                    <th>Posición</th>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th>Categoría</th>
                    <th>Tipo de item</th>
                    <th>Cantidad</th>
                    <th>Precio</th>
                    <th>Coste</th>
                    <th>% Descuento</th>
                    <th>IVA</th>
                    <th>Total Imp.</th>
                    <th>Retención</th>
                    <th>Total</th>
                    <th>% Utilidad</th>
                    <th>Mostrar Obs.</th>
                    <th>Observación</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr @cambiarIndice="cambiarIndice" :totalItems="modelValue.length" @changed="changedItem" :retencionServicios="retencionServicios" 
                    :retencionProductos="retencionProductos" :errores="errores" @eliminar="eliminarItem" @updated="updatedTr" :valorIrbpnr="irbpnr" 
                    v-model="modelValue[index]" :tarifas="tarifas" :index="index" is="item-proforma" 
                    v-for="(item, index) in modelValue" :key="moment(new Date()).format('YYYYMMDDHH:mm:ss') + index"
                    v-show="similiarToSearch(modelValue[index].selectedItem?modelValue[index].selectedItem.nombre:'') || similiarToSearch(modelValue[index].descripcion)">
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2">
                        <button type="button" class="btn-success" @click="addRow">
                            <i class="fa fa-plus"></i>
                        </button>
                    </td>
                    <td colspan="2">
                        <div class="form-group">
                            <input-field placeholder="###.## %" vMoney :format="porcentaje" id="margenTotal" v-model="margenTotal">
                                <span>Marg. Total %</span>
                            </input-field>
                            <button @click="calcularMarginacionPorItem" class="btn-secondary"><i class="fa fa-check"></i></button>
                        </div>
                    </td>
                    <td colspan="2">
                        <button @click="verTotales" class="btn-info btn--text" type="button"><i class="fa fa-eye"></i><span>Ver totales</span></button>
                    </td>
                    <td><strong v-show="!totalesOcultos">Cant. totales</strong></td>
                    <td>
                        <input-field id="cantidadesTotales" vMoney :format="decimal" :value="cantidades_totales" v-show="!totalesOcultos"></input-field>
                    </td>
                    <td colspan="2"><strong v-show="!totalesOcultos">Costos totales</strong></td>
                    <td>
                        <input-field id="costosTotales" vMoney :format="money" :value="costes_totales" v-show="!totalesOcultos"></input-field>
                    </td>
                    <td><strong v-show="!totalesOcultos">Total</strong></td>
                    <td>
                        <input-field id="totales" vMoney :format="money" :value="totales" v-show="!totalesOcultos"></input-field>
                    </td>
                    <td><strong v-show="!totalesOcultos">Util.</strong></td>
                    <td>
                        <input-field id="utilidadTotal" vMoney :format="money" :value="margen_utilidad" v-show="!totalesOcultos"></input-field>
                    </td>
                    <td><strong v-show="!totalesOcultos">%Util.</strong></td>
                    <td>
                        <input-field id="porcentajeUtilidad" vMoney :format="decimal" :value="porcentaje_utilidad" v-show="!totalesOcultos"></input-field>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import clusterize from "vue-clusterize"
export default {
    components: {
    "clusterize": clusterize
    },
    props : {
        value : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        search: {
            required: false,
            default: ''
        },
        tarifas : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        irbpnr : {
            type : Number,
            required : true
        },
        errores : {
            type : Object,
            required : true
        },
        retencionProductos : {
            type : Number,
            required : true
        },
        retencionServicios : {
            type : Number,
            required : true 
        }
    },
    data : function () {
        return {
            modelValue : this.value,
            selectedIndex : -1,
            decimal : decimal,
            money : money,
            money2 : money2,
            moneyNegative : moneyNegative,
            porcentajeNegative : porcentajeNegative,
            totalesOcultos : true,
            moment : moment,
            moneyFormat : moneyFormat,
            decimalFormat : decimalFormat,
            cantidades_totales : 0,
            costes_totales : 0,
            totales : 0,
            margen_utilidad : 0,
            porcentaje_utilidad : 0,
            porcentaje : porcentaje,
            margenTotal : 0
        };
    },
    methods : {
        similiarToSearch: function(value) {
            let searchItems = this.search;
            if (searchItems === "")
                return true;
            else
                return (
                    value.toUpperCase().indexOf(searchItems.toUpperCase()) != -1
                );
        },
        calcularMarginacionPorItem : function () {
            let margenTotal = parseFloat(this.margenTotal);
            if (!isNaN(margenTotal)) 
                for (let i = 0; i < this.modelValue.length; i++) {
                    let costo = parseFloat(this.modelValue[i].coste);
                    if (isNaN(costo))
                        costo = 0;
                    let precio = round(costo * (1 + margenTotal / 100));
                    this.modelValue[i].precio = precio;
                }
            else 
                swal('El porcentaje debe tener un número válido.', 'Aviso', 'warning');
        },
        cambiarIndice : function (newIndex, row) {
            let indexAnterior = this.modelValue.indexOf(row);
            this.modelValue.splice(indexAnterior, 1);
            this.modelValue.splice(newIndex, 0, row);
        },
        calcularPorcentajeUtilidad : function () {
            let totales = 0;
            for (let i = 0; i < this.modelValue.length; i++)
            {
                let precio = parseFloat(this.modelValue[i].precio);
                let cantidad = parseFloat(this.modelValue[i].cantidad);
                if (!isNaN(precio) && !isNaN(cantidad))
                    totales += precio * cantidad;
            }
            this.porcentaje_utilidad = round(this.margen_utilidad / ((totales === 0)?1:totales) * 100);
        },
        changedItem : function () {
            if (!this.totalesOcultos)
                this.totalesOcultos = true;
        },
        calcularCantidadesTotales : function () {
            let cantidadesTotales = 0;
            for (let i = 0; i < this.modelValue.length; i++)
            {
                let cantidad = parseFloat(this.modelValue[i].cantidad);
                if (isNaN(cantidad))
                    cantidad = 0;
                cantidadesTotales += cantidad;
            }
            this.cantidades_totales = cantidadesTotales;
        },
        calcularMargenUtilidad : function () {
            let margenUtilidad = 0;
            for (let i = 0; i < this.modelValue.length; i++) {
                let cantidad = parseFloat(this.modelValue[i].cantidad);
                if (isNaN(cantidad))
                    cantidad = 0;
                let precio = parseFloat(this.modelValue[i].precio);
                if (isNaN(precio))
                    precio = 0;
                let coste = parseFloat(this.modelValue[i].coste);
                if (isNaN(coste))
                    coste = 0;
                let descuento = parseFloat(this.modelValue[i].total_descuento);
                if (isNaN(descuento))
                    descuento = 0;
                let retencion = parseFloat(this.modelValue[i].retencion);
                if (isNaN(retencion))
                    retencion = parseFloat(this.modelValue[i].retencion);
                margenUtilidad += ((precio * cantidad) - descuento - (coste * cantidad) - retencion);
            }
            this.margen_utilidad = margenUtilidad;
        },
        calcularTotales : function () {
            let total = 0;
            for (let i = 0; i < this.modelValue.length; i++)
            {
                let cantidad = parseFloat(this.modelValue[i].cantidad);
                if (isNaN(cantidad))
                    cantidad = 0;
                let precio = parseFloat(this.modelValue[i].precio);
                if (isNaN(precio))
                    precio = 0;
                total += precio * cantidad;
            }
            this.totales = total;
        },
        calcularCostosTotales : function () {
            let costesTotales = 0;
            for (let i = 0; i < this.modelValue.length; i++)
            {
                let cantidad = parseFloat(this.modelValue[i].cantidad);
                if (isNaN(cantidad))
                    cantidad = 0;
                let coste = parseFloat(this.modelValue[i].coste);
                if (isNaN(coste))
                    coste = 0;
                costesTotales += coste * cantidad;
            }
            this.costes_totales = costesTotales;
        },
        updatedTr : function () {
            this.$emit('updated');
        },
        verTotales : function () {
            if (this.totalesOcultos) 
            {
                this.calcularCantidadesTotales();
                this.calcularCostosTotales();
                this.calcularTotales();
                this.calcularMargenUtilidad();
                this.calcularPorcentajeUtilidad();
            } 
            this.totalesOcultos = !this.totalesOcultos;
        },
        addRow : function () {
            this.selectedIndex = this.modelValue.push({
                    id_item : '',
                    tipo_item : 'P',
                    nombre_item : '',
                    cantidad : 1,
                    precio : 0,
                    total_descuento : 0,
                    total_impuestos : 0,
                    selectedTarifa : null,
                    selectedCategoria : null,
                    selectedItem : null,
                    total_inicial : 0,
                    total_parcial : 0,
                    irbpnr : false,
                    cantidad_irbpnr : 0,
                    total_irbpnr : 0,
                    porcentaje_iva : 0,
                    iva : 0,
                    porcentaje_ed_valorem : 0,
                    precio_produccion : 0,
                    total_parcial_ice : 0,
                    porcentaje_ice : 0,
                    numero_unidades_ice : 0,
                    tarifa_especifica_ice : 0,
                    cantidad_ice : 0,
                    ice : 0,
                    precio_sin_subsidio : 0,
                    valor_subsidio : 0,
                    id_iva : '4',
                    id_ice : '',
                    total : 0,
                    porcentaje_descuento : 0,
                    coste : 0,
                    observacion : '',
                    descripcion : '',
                    mostrar_detalle : false,
                    retencion : 0
                }) - 1;
        },
        eliminarItem : function (index) {
            swal({
                title: '¿Deseas eliminar este item?',
                text: "Esta acción requiere de confirmación.",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText : 'No'
            }).then((result) => {
                if (result.value)
                {
                    this.modelValue.splice(index, 1);
                    this.$emit('updated');
                }
            });
        }
    },
    watch : {
        value : function (value) {
            this.modelValue = value;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/TablaItemsProforma.vue